import { useState } from 'react';
import { supabase } from '../../../lib/supabase';

function getResetRedirectTo() {
  return `${window.location.origin}/reset-password`;
}

export function usePasswordReset() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendPasswordReset = async (userEmail: string, userName: string): Promise<boolean> => {
    setLoading(true);
    setError(null);

    try {
      const { error: resetError } = await supabase.functions.invoke('send-password-reset', {
        body: {
          userEmail,
          userName,
          redirectTo: getResetRedirectTo()
        }
      });

      if (resetError) {
        throw resetError;
      }

      return true;

    } catch (err) {
      const message = err instanceof Error ? err.message : 'Error desconocido';
      setError(message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { sendPasswordReset, loading, error };
}
